<chart *ngIf="settings" type="line" [options]="settings.options" [data]="settings.data"> </chart>
